import abi from './contract-abi_RPS';

export const contractABI = abi;
export const oneEther = 1000000000000000000;
export const creamCost = 0.0001;
